import {
  ApiTag,
  ApiAuthoredContentLanguage,
  ApiAuthoredContent,
  ApiCompany,
  ApiDefinition,
  Feature,
} from '../types/api-definitions';
import {
  ApiTagDto,
  ApiAuthoredContentLanguageDto,
  ApiAuthoredContentDto,
  ApiCompanyDto,
  ApiDefinitionDto,
  FeatureDto,
} from '../types/api';
import { transformMediaUrl } from '../utils/apiUtils';

export const mapApiTag = (dto: ApiTagDto): ApiTag => {
  return {
    slug: dto.slug,
    name: dto.name,
    color: dto.color,
  };
};

export const mapFeature = (dto: FeatureDto, locale: string): Feature => {
  return {
    id: dto.id,
    slug: dto.slug,
    name: dto.name,
    descriptionShort: dto.descriptionShort,
    descriptionLong: dto.descriptionLong,
    demoContent: dto.demoContent,
    locale: locale,
    imagePath: transformMediaUrl(dto.imagePath),
    tags: dto.tags?.map((tag) => mapApiTag(tag)) || [],
  };
};

export const mapApiAuthoredContentLanguage = (
  dto: ApiAuthoredContentLanguageDto,
  locale: string,
): ApiAuthoredContentLanguage => {
  return {
    title: dto.title,
    descriptionShort: dto.descriptionShort,
    descriptionLong: dto.descriptionLong,
    tags: dto.tags?.map((tag) => mapApiTag(tag)) || [],
    features: dto.features?.map((feature) => mapFeature(feature, locale)) || [],
    sla: dto.sla,
    contacts: dto.contacts,
  };
};

export const mapApiAuthoredContent = (dto: ApiAuthoredContentDto): ApiAuthoredContent => {
  return {
    en: dto.en ? mapApiAuthoredContentLanguage(dto.en, 'en') : undefined,
    nl: dto.nl ? mapApiAuthoredContentLanguage(dto.nl, 'nl') : undefined,
  };
};

export const mapApiCompany = (dto: ApiCompanyDto): ApiCompany => {
  return {
    name: dto.name,
    logoPath: transformMediaUrl(dto.logoPath),
  };
};

export const mapApiDefinition = (dto: ApiDefinitionDto): ApiDefinition => {
  return {
    id: dto.id,
    slug: dto.slug,
    name: dto.name,
    protocols: dto.protocols,
    apiVersion: dto.apiVersion,
    isOnline: dto.isOnline,
    isPublic: dto.isPublic,
    hasDocumentationArticles: dto.hasDocumentationArticles,
    hasOpenApiSpec: dto.hasOpenApiSpec,
    lastSyncDateTime: dto.lastSyncDateTime,
    company: mapApiCompany(dto.company),
    authoredContent: mapApiAuthoredContent(dto.authoredContent),
  };
};

export const mapApiDefinitions = (dtos: ApiDefinitionDto[]): ApiDefinition[] => {
  return dtos.map((dto) => mapApiDefinition(dto));
};
